import * as UI from "@iyk/ui"

type ProtectedImageProps = React.ImgHTMLAttributes<HTMLImageElement>

/**
 * ProtectedImage is a component that prevents the image from being dragged, copied, or right-clicked.
 * This does not completely prevent the image from being downloaded, as the user could take a screenshot.
 * But it solves the problem for the average user who does not have HTML knowledge to bypass this restriction.
 */
export function ProtectedImage({ className, ...props }: ProtectedImageProps) {
  return (
    <img
      draggable={false}
      onContextMenu={(e) => e.preventDefault()}
      className={UI.cx("size-full object-contain select-none pointer-events-none", className)}
      {...props}
    />
  )
}
